import React from 'react';
import PropTypes from 'prop-types';
import IconButton from 'material-ui/IconButton';
import IconMenu from 'material-ui/IconMenu';
import MoreVertIcon from 'material-ui/svg-icons/navigation/more-vert';

const style = {
    svg: {
        fill: '#FFF !important',
    }
};

/**
 *
 * ToolbarMenu with default items for common actions
 *
 * @prop array|object items, MenuItem(s) to show in the context menu
 */
const ToolbarMenu = ({items}) => (
    <IconMenu
        iconButtonElement={<IconButton iconStyle={style.svg}><MoreVertIcon/></IconButton>}
        targetOrigin={{ horizontal: 'right', vertical: 'top' }}
        anchorOrigin={{ horizontal: 'right', vertical: 'top' }}
    >
        {items}
    </IconMenu>
);

ToolbarMenu.propTypes = {
    items: PropTypes.oneOfType([
        PropTypes.object,
        PropTypes.arrayOf(PropTypes.object)
    ]).isRequired
};

export default ToolbarMenu;
